import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../store/modules/app';
import OpenReturnExchangeAttachment from '../../../views/app/common/OpenReturnExchangeAttachment';

class OpenReturnExchangeAttachmentContainer extends Component {
  render() {
    return <OpenReturnExchangeAttachment {...this.props} />;
  }
}

const mapDispatchToProps = {
  getRequestRejectAttachmentData: appActions.getRequestRejectAttachmentData,
};

export default connect(null, mapDispatchToProps)(OpenReturnExchangeAttachmentContainer);
